export type MeetingLinkJoinMethodResult = {
  joinMethodId: number;
  value?: string;
  error?: string;
};

type MeetingLinkRegistrationSource = {
  registrationResult?: string | null;
  results?: Array<Partial<MeetingLinkJoinMethodResult>> | null;
};

const readResultItems = (source: MeetingLinkRegistrationSource): Array<Partial<MeetingLinkJoinMethodResult>> => {
  if (source.results?.length) {
    return source.results;
  }

  const raw = source.registrationResult?.trim();
  if (!raw || !raw.startsWith('{')) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw) as { results?: Array<Partial<MeetingLinkJoinMethodResult>> };
    return Array.isArray(parsed.results) ? parsed.results : [];
  } catch {
    return [];
  }
};

const normalizeResults = (source: MeetingLinkRegistrationSource): MeetingLinkJoinMethodResult[] => {
  return readResultItems(source).flatMap(item => {
    if (typeof item?.joinMethodId !== 'number' || typeof item.value !== 'string' || !item.value) {
      return [];
    }
    return [{ joinMethodId: item.joinMethodId, value: item.value }];
  });
};

export const resolveMeetingLinkJoinError = (
  source: MeetingLinkRegistrationSource,
  joinMethodId?: number
): string | null => {
  const items = readResultItems(source).filter(item => {
    if (typeof item?.joinMethodId !== 'number') {
      return false;
    }
    return joinMethodId == null || item.joinMethodId === joinMethodId;
  });
  const failed = items.find(item => typeof item.error === 'string' && !!item.error && !item.value);
  return failed?.error ?? null;
};

export const resolveMeetingLinkJoinValue = (
  source: MeetingLinkRegistrationSource,
  joinMethodId?: number
): string | null => {
  const results = normalizeResults(source);
  if (results.length) {
    if (joinMethodId != null) {
      return results.find(item => item.joinMethodId === joinMethodId)?.value ?? null;
    }
    return results.length === 1 ? results[0].value : null;
  }

  const raw = source.registrationResult?.trim();
  if (!raw || raw.startsWith('{') || raw.startsWith('[')) {
    return null;
  }
  return raw;
};
